<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  ><path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8.15 2.47c.826-1.418 2.874-1.418 3.701 0l7.513 12.879c.833 1.428-.197 3.222-1.851 3.222H2.487c-1.654 0-2.684-1.794-1.85-3.222l7.512-12.88ZM10 5.893c.592 0 1.072.48 1.072 1.071v3.929a1.071 1.071 0 0 1-2.143 0V6.964c0-.591.48-1.071 1.071-1.071Zm1.429 8.928a1.429 1.429 0 1 1-2.858 0 1.429 1.429 0 0 1 2.858 0Z"
    clip-rule="evenodd"
  /></svg>
</template>
